import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CatalogService } from '../services/catalog.service';
import { TranslateService } from '@ngx-translate/core';

export const CatalogEditResolver: ResolveFn<any> = async (route, state) => {
  const id = route.paramMap.get('id');
  const catalogService = inject(CatalogService);
  const trans = inject(TranslateService);

  try {
    const [catalog, listLabel, editLabel] = await Promise.all([
      firstValueFrom(catalogService.getCatalog(id)),
      firstValueFrom(trans.get('CATALOG.LIST')),
      firstValueFrom(trans.get('CATALOG.EDIT')),
    ]);

    return [
      { label: listLabel, url: '/catalog/list' },
      { label: catalog?.name ?? id, url: `/catalog/${id}/fascicles` },
      { label: editLabel },
    ];
  } catch {
    return [];
  }
};
